export default __webpack_public_path__ + "static/media/6.a58f02e7.svg";